<template>
    <v-container
        fluid
        class="sidebar-content general-sidebar_inside map-sidebar"
        ref="sidebarMap"
    >
        <div
            class="point pb-8"
            v-for="(point, id) in data.points"
            :key="`point-${id}`"
        >
            <div class="scrolable-box-heading">
                <h3>
                    {{point.text}}
                </h3>
            </div>
            <v-list class="props-list props-list_wide">
                <v-list-item
                    v-for="(item, id) in point.categories"
                    :key="`category-${id}`"
                    class="pl-4"
                    :class="{ 'pb-2': id < point.categories.length - 1 }"
                >
                    <a
                        href="#"
                        class="d-flex"
                        :class="{ 'active': item.active }"
                        @click.prevent="toggleState(item)"
                    >
                        <span class="icon-holder pr-2">
                            <svg
                                width="20"
                                height="20"
                            >
                                <image
                                    v-if="item.active"
                                    :xlink:href="item.icon"
                                    :src="item.icon"
                                    width="20"
                                    height="20"
                                />
                                <image
                                    v-else
                                    :xlink:href="item.inactiveIcon"
                                    :src="item.inactiveIcon"
                                    width="20"
                                    height="20"
                                />
                            </svg>
                        </span>
                        <span class="pb-1">
                            {{ item.text }}
                        </span>
                    </a>
                </v-list-item>
            </v-list>
        </div>
    </v-container>
</template>

<script>
    export default {
        name: 'MapSidebar',
        props: [
            'data',
            'handler'
        ],
        mounted() {
            this.handler();
        },
        methods: {
            toggleState(item) {
                this.$set(item, 'active', !item.active);
                this.data.refreshHotspots(item, item.active);
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/layout/sidebar/MapSidebar.vue